import { render, staticRenderFns } from "./Footer_Compontent.vue?vue&type=template&id=2dede168&scoped=true&"
import script from "./Footer_Compontent.vue?vue&type=script&lang=js&"
export * from "./Footer_Compontent.vue?vue&type=script&lang=js&"
import style0 from "./Footer_Compontent.vue?vue&type=style&index=0&id=2dede168&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dede168",
  null
  
)

export default component.exports